import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

/*
    we do have this wrapper so that we can change it's underlying implementation if needed,
    so we do not hook up all of our code against a specific library but a abstraction instead
 */

@Injectable({
    providedIn: 'root',
})
export class SpinnerService 
{
    constructor(
        private _spinner: NgxSpinnerService)
    {
    }

    public showSpinner(): void 
    {
        this._spinner.show();
    } // showSpinner

    public hideSpinner(): void 
    {
        this._spinner.hide();
    } // hideSpinner
}
